const URL_BASE=process.env.REACT_APP_API;

export const URL_MADE=`${URL_BASE}/financial/payments/made`;
